import { createAction, props } from '@ngrx/store';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { ResultProc } from '@app/models/system/result-proc.model';

// pdt detail
export const loadPdtInfo = createAction(
  "[Product API] load pdt info",
  props<{ pdtCd: string, userid: string }>()
);

export const loadPdtInfoSuccess = createAction(
  "[Product API] load pdt info success",
  props<{ item: PdtDetailModel }>()
);

export const loadPdtInfoFailure = createAction(
  "[Product API] load pdt info failure",
  props<{ msg: any }>()
);

// pdt image
export const loadPdtImages = createAction(
  "[Product API] load pdt images",
  props<{ pdtCd: string, pathKind: string }>()
);

export const loadPdtImagesSuccess = createAction(
  "[Product API] load pdt images success",
  props<{ items: PdtDetailModel[] }>()
);

export const loadPdtImagesFailure = createAction(
  "[Product API] load pdt images failure",
  props<{ msg: any }>()
);

// pdt notify
export const loadPdtNotify = createAction(
  "[Product API] load pdt notify",
  props<{ pdtCd: string }>()
);

export const loadPdtNotifySuccess = createAction(
  "[Product API] load pdt notify success",
  props<{ items: PdtDetailModel[] }>()
);

export const loadPdtNotifyFailure = createAction(
  "[Product API] load pdt notify failure",
  props<{ msg: any }>()
);

// getPdtInfosByCateCd
export const loadPdtInfosByCateCd = createAction(
  "[Product API] loadPdtInfosByCateCd",
  (catecd: string, rowNum: string, prdCd: string, pathKind: string) => ({ catecd, rowNum, prdCd, pathKind })
);

export const loadPdtInfosByCateCdSuccess = createAction(
  "[Product API] loadPdtInfosByCateCd success",
  props<{ relatedProducts: PdtDetailModel[] }>()
);

export const loadPdtInfosByCateCdFailure = createAction(
  "[Product API] loadPdtInfosByCateCd failure",
  props<{ msg: any }>()
);


// set product name main heading
export const setProductNameMainHeading = createAction(
  "[Product Detail] set product name main heading",
  props<{ heading: string }>()
);

// clear product detail state
export const clearProductDetailState = createAction("[Product Detail] clear product detail state");

// set main heading
export const setMainHeading = createAction(
  "[Product Detail] set product name main heading",
  props<{ main: string }>()
);

// set children heading
export const setChildrenHeading = createAction(
  "[Product Detail] set product name main heading",
  props<{ child: string }>()
);

// getPdtReview
export const getPdtReview = createAction(
  "[Product API] getPdtReview",
  props<{ pdtCd: string ,orderBy:string, page:number, len:number}>()
);

export const getPdtReviewSuccess = createAction(
  "[Product API] getPdtReview success",
  props<{ reviewProducts: PdtDetailModel[] }>()
);

export const getPdtReviewFailure = createAction(
  "[Product API] getPdtReview failure",
  props<{ msg: any }>()
);

// savePdtReviews
export const savePdtReviews = createAction(
  "[Product API] save Product Reviews",
  props<{ params: any }>()
);

export const savePdtReviewsSuccess = createAction(
  "[Product API] save Product Reviews success",
  props<{ result: ResultProc }>()
);

export const savePdtReviewsFailure = createAction(
  "[Product API] save Product Reviews failure",
  props<{ msg: any }>()
);

//Check Review Product
export const checkReviewPdt = createAction(
  "[Product API] check Review Product",
  props<{ userid: string, pdtCd: string }>()
);

export const checkReviewPdtSuccess = createAction(
  "[Product API] check Review Product Success",
  props<{ count: Number }>()
);

export const checkReviewPdtFailure = createAction(
  "[Product API] check Review Product Failure",
  props<{ msg: any }>()
);

// set children heading
export const setReviewCount = createAction(
  "[Product Detail] set Count Review",
  props<{ count: any }>()
);


// countPdtRewiew
export const getCountPdtReview = createAction(
  "[Product API] getCountPdtReview",
  props<{ pdtCd: string }>()
);

export const getCountPdtReviewSuccess = createAction(
  "[Product API] getCountPdtReviewSuccess success",
  props<{ total: Number }>()
);

export const getCountPdtReviewFailure = createAction(
  "[Product API] getCountPdtReviewFailure failure",
  props<{ msg: any }>()
);

// get grades of review
export const getGradeOfProduct = createAction(
  "[Product API] get grades of product",
  props<{ pdtCd: string }>()
);

export const getGradeOfProductSuccess = createAction(
  "[Product API] get grades of product success",
  props<{ gradeOfProducts: PdtDetailModel[] }>()
);

export const getGradeOfProductFailure = createAction(
  "[Product API] get grades of product failure",
  props<{ msg: any }>()
);
